import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import MyAccount from './shop-components/my-account';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import TopBar from './global-components/topbar';

const MyaccountV1 = () => {
    return <div>
        <TopBar/>
        <Navbar />
        <PageHeader headertitle="My Account" />
        <MyAccount />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default MyaccountV1

